module.exports = __webpack_public_path__ + "static/media/ic_empty.9ddd7d31.svg";